import { SpreadGroup } from 'editor/src/store/design/types';
import { VariantsState } from 'editor/src/store/variants/types';

const getSpreadGroupsForGivenVariant = (state: VariantsState, productId: string): SpreadGroup[] | undefined =>
  state.groupedSpreadsPerProductUids[productId];

export default getSpreadGroupsForGivenVariant;
